import { generateIdByUUID } from 'core/utils/coreUtil'

export const nextElementId = (prefix: string, reserved?: Set<string>) => {
    let id = `${prefix}-${generateIdByUUID()}`
    while (reserved?.has(id)) {
        id = `${prefix}-${generateIdByUUID()}`
    }
    reserved?.add(id)
    return id
}
